import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  ErrorMsg,
  DateWrapper,
} from "@onegovbugs/onegov-react-components";
import styles from "./Qualification.module.scss";
import {
  isCompleted,
  validate,
  scrollToError,
  isAFutureDate,
  isDateValid,
  objExistInArray,
} from "../../../utils/Validation";
import { RedirectIfCaptchaNotSelected } from "../../../utils/Redirect";
import { withRouter } from "react-router-dom";
import { storeQualificationDetail } from "../../../redux/actions";

const QualificationForm = (props) => {
  RedirectIfCaptchaNotSelected(props);
  const dispatch = useDispatch();

  let index = props.match.params.id;

  const qualificationDetail = useSelector((state) => state.qualificationDetail);
  const [qualificationList, setQualificationList] = useState(
    qualificationDetail && qualificationDetail.qualificationList
      ? qualificationDetail.qualificationList.map((on) => ({ ...on }))
      : []
  );
  const editQualification =
    index && qualificationList && qualificationList.length > 0
      ? qualificationList[index]
      : undefined;

  const [courseName, setCourseName] = useState(
    editQualification ? editQualification.courseName : ""
  );
  const [issuingAuthority, setIssuingAuthority] = useState(
    editQualification ? editQualification.issuingAuthority : ""
  );
  const [institutionName, setInstitutionName] = useState(
    editQualification ? editQualification.institutionName : ""
  );
  const [certificateName, setCertificateName] = useState(
    editQualification ? editQualification.certificate : ""
  );
  const [details, setDetails] = useState(
    editQualification ? editQualification.details : ""
  );
  const [certificateDate, setCertificateDate] = useState(
    editQualification ? editQualification.certificateDate : ""
  );
  const [dayOfCertificateDate, setDayOfCertificateDate] = useState(
    editQualification ? editQualification.dayOfCertificateDate : ""
  );
  const [monthOfCertificateDate, setMonthOfCertificateDate] = useState(
    editQualification ? editQualification.monthOfCertificateDate : ""
  );
  const [yearOfCertificateDate, setYearOfCertificateDate] = useState(
    editQualification ? editQualification.yearOfCertificateDate : ""
  );
  const [isCertificateDateValids, setIsCertificateDateValid] = useState(true);
  const [isCertificateDateRequired, setIsCertificateDateRequired] = useState(
    true
  );
  const [limitDetailErrorMsg, setDetailCharLimitErrorMsg] = useState("You have 200 characters left.");

  // Validation
  const [showErrors, setShowErrors] = useState(false);

  const [errors, setErrors] = useState({
    dayOfCertificateDate: false,
    monthOfCertificateDate: false,
    yearOfCertificateDate: false,
    issuingAuthority: false,
    institutionName: false,
    qualAlreadyExists: false,
  });
  const validators = [
    {
      fieldName: "issuingAuthority",
      fieldValue: issuingAuthority,
      isValid: isCompleted,
    },
    {
      fieldName: "institutionName",
      fieldValue: institutionName,
      isValid: isCompleted,
    },
    {
      fieldName: "isDateRequired",
      fieldValue: {
        day: dayOfCertificateDate,
        month: monthOfCertificateDate,
        year: yearOfCertificateDate,
      },
      isValid: (v) =>
        dayOfCertificateDate && monthOfCertificateDate && yearOfCertificateDate,
    },
    {
      fieldName: "isCertificateDateValid",
      fieldValue: {
        day: dayOfCertificateDate,
        month: monthOfCertificateDate,
        year: yearOfCertificateDate
      },
      isValid: isDateValid,
    },
    {
      fieldName: "isDateValidAndPast",
      fieldValue: {
        day: dayOfCertificateDate,
        month: monthOfCertificateDate,
        year: yearOfCertificateDate
      },
      isValid: (v) => !(isAFutureDate(dayOfCertificateDate, monthOfCertificateDate,yearOfCertificateDate)),
    },
    {
      fieldName: "qualAlreadyExists",
      fieldValue: qualificationList,
      isValid: (v) => {
        if ((v && v.length === 0) || index !== undefined) return true;
        const qual = {
          courseName: courseName ? courseName : "",
          issuingAuthority: issuingAuthority ? issuingAuthority : "",
          dayOfCertificateDate: dayOfCertificateDate,
          monthOfCertificateDate: monthOfCertificateDate,
          yearOfCertificateDate: yearOfCertificateDate,
        };

        return objExistInArray(v, qual);
      },
    },
  ];

  useEffect(() => {
    validate(validators, setErrors);
  }, [
    issuingAuthority,
    institutionName,
    dayOfCertificateDate,
    monthOfCertificateDate,
    yearOfCertificateDate,
  ]);

  const storeData = (qual) => {
    const qualificationRecord = {
      hasQualification: "yes",
      qualificationList: [
        ...qualificationList,
        {
          courseName: qual.courseName,
          issuingAuthority: qual.issuingAuthority,
          dayOfCertificateDate: qual.dayOfCertificateDate,
          monthOfCertificateDate: qual.monthOfCertificateDate,
          yearOfCertificateDate: qual.yearOfCertificateDate,
          institutionName: qual.institutionName,
          certificateName: qual.certificateName,
          details: qual.details
        },
      ],
    };

    dispatch(storeQualificationDetail(qualificationRecord));
  };

  const editData = (updatedQual) => {
    const qualificationRecord = {
      hasQualification: "yes",
      qualificationList: updatedQual,
    };

    dispatch(storeQualificationDetail(qualificationRecord));
  };

  const saveQualificationDataHandler = (qual) => {
    if (qualificationList && qualificationList.length > 0) {
      if (index) {
        let updatedQual = [...qualificationList];

        updatedQual[index] = {
          courseName: qual.courseName,
          issuingAuthority: qual.issuingAuthority,
          dayOfCertificateDate: qual.dayOfCertificateDate,
          monthOfCertificateDate: qual.monthOfCertificateDate,
          yearOfCertificateDate: qual.yearOfCertificateDate,
          institutionName: qual.institutionName,
          certificateName: qual.certificateName,
          details: qual.details
        };
        editData(updatedQual);
      } else {
        storeData(qual);
      }
    } else {
      storeData(qual);
    }
  };

  const saveQualificationData = () => {
    const newQualification = {
      courseName: courseName,
      issuingAuthority: issuingAuthority,
      dayOfCertificateDate: dayOfCertificateDate,
      monthOfCertificateDate: monthOfCertificateDate,
      yearOfCertificateDate: yearOfCertificateDate,
      institutionName: institutionName,
      certificateName: certificateName,
      details: details
    };
    saveQualificationDataHandler(newQualification);
  };

  const onKeyUp = (v) => {
    const maxLength = 200;
    let currentLength = v.length;
    if (currentLength >= maxLength) {
      setDetailCharLimitErrorMsg("You have reached the limit");
    } else {
      var charLeft = maxLength - currentLength;
      setDetailCharLimitErrorMsg("You have " + charLeft + " characters left.");     
    }
  };


  return (
    <div className={styles.mainCont}>
      <div className={"row"}>
        <div className={"col-12 col-sm-6"}>
          <label htmlFor="issuingAuthority">Issuing Authority</label>
          <input
            id="issuingAuthority"
            className={styles.inputBox}
            value={issuingAuthority}
            onChange={(event) => {
              setIssuingAuthority(event.target.value);
            }}
            maxLength={50}
          />
          {errors.issuingAuthority && showErrors ? (
            <ErrorMsg
              className={"ErrorMsg_error"}
              type={"error"}
              description={"Issuing Authority is required."}
            />
          ) : null}
        </div>
        <div className={"col-12 col-sm-6"}>
          <label htmlFor="courseName">Institution Name</label>
          <input
            id={"institutionName"}
            value={institutionName}
            className={styles.inputBox}
            onChange={(event) => {
              setInstitutionName(event.target.value);
            }}
            maxLength={50}
          />
          {errors.institutionName && showErrors ? (
            <ErrorMsg
              className={"ErrorMsg_error"}
              type={"error"}
              description={"Institution Name is required."}
            />
          ) : null}
        </div>
      </div>
      <div className={"row"}>
        <div className={"col-12 col-sm-6"}>
          <label htmlFor="certificateName">Certificate Name (Optional)</label>
          <input
            id={"certificateName"}
            value={certificateName}
            className={styles.inputBox}
            onChange={(event) => {
              setCertificateName(event.target.value);
            }}
            maxLength={50}
          />
        </div>
        <div className={"col-12 col-sm-6"}>
          <label htmlFor="courseName">Course Name (Optional)</label>
          <input
            id={"courseName"}
            value={courseName}
            className={styles.inputBox}
            onChange={(event) => {
              setCourseName(event.target.value);
            }}
            maxLength={50}
          />
        </div>
      </div>
      <div className={"row"}>
        <div className={`col-12 col-sm-6`}>
          <label htmlFor="certificateDate">Certificate Date</label>
          <DateWrapper
            setDayOfBirth={setDayOfCertificateDate}
            setMonthOfBirth={setMonthOfCertificateDate}
            setYearOfBirth={setYearOfCertificateDate}
            onValidationChange={setIsCertificateDateValid}
            onValidationRequired={setIsCertificateDateRequired}
            day={dayOfCertificateDate}
            month={monthOfCertificateDate}
            year={yearOfCertificateDate}
            autotab
          ></DateWrapper>
          {showErrors ? (
            errors.isDateRequired ? (
              <ErrorMsg
                className={"ErrorMsg_error"}
                type={"error"}
                description={"Certificate Date is required."}
              />
            ) : errors.isCertificateDateValid ? (
              <ErrorMsg
                className={"ErrorMsg_error"}
                type={"error"}
                description={"Certificate Date invalid."}
              />
            ) : isAFutureDate(
                dayOfCertificateDate,
                monthOfCertificateDate,
                yearOfCertificateDate
              ) == true ? (
              <ErrorMsg
                className={"ErrorMsg_error"}
                type={"error"}
                description={"Certificate Date cannot be in the future."}
              />
            ) : null
          ) : null}
        </div>
        <div className={"col-12 col-sm-6"}>
          <label htmlFor="detail">Details (Optional)</label>
          <textarea
            id="detail"
            value={details}
            onChange={(event) => {
              setDetails(event.target.value);
            }}
            onKeyUp={(event) => {
              onKeyUp(event.target.value, "details");
            }}
            maxLength="200"
          />
          <span>{limitDetailErrorMsg}</span>
        </div>
      </div>
      
      {errors.qualAlreadyExists && showErrors ? (
        <ErrorMsg
          className={"ErrorMsg_error"}
          type={"error"}
          description={"Qualification detail already exists."}
        />
      ) : null}
      <div className={"row " + styles.buttonCont}>
        <div className={"col-12"}>
          <Button
            onClick={() => {
              if (validate(validators, setErrors)) {
                saveQualificationData();
                props.history.push(`/flora-fauna/qualification`);
              } else {
                setShowErrors(true);
                scrollToError();
              }
            }}
          >
            Save
          </Button>
          <Button
            secondary
            onClick={() => {
              //toggleAddQualificationForm(false);
              setShowErrors(false);
              props.history.push(`/flora-fauna/qualification`);
            }}
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default withRouter((props) => <QualificationForm {...props} />);
